import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'src/common/components/common/disclaimer-dialog';
import { StrikeoutPrice } from './strikeout-price';

const LinkTracked = ClickTracker(Link);

export interface StrikeoutPriceAndInfoContainerProps {
  strikeoutDisclaimer?: string;
  strikeOut?: string;
  query?: any;
  dialogId?: string;
  handleClose?: () => void;
  wrapPrice?: boolean;
  dialogType?: string;
  layerId?: string;
}

export const StrikeoutPriceAndInfoContainer: React.FunctionComponent<StrikeoutPriceAndInfoContainerProps> = ({
  strikeoutDisclaimer,
  query,
  strikeOut,
  dialogId,
  handleClose,
  wrapPrice,
  dialogType,
  layerId,
}) => {
  const disclaimerTrigger = React.useRef(null);

  const onDisclaimerDialogClose = () => {
    handleClose();
    if (
      disclaimerTrigger &&
      disclaimerTrigger.current &&
      disclaimerTrigger.current.focus &&
      typeof disclaimerTrigger.current.focus === 'function'
    ) {
      disclaimerTrigger.current.focus();
    }
  };

  const triggerRef = disclaimerTriggerRef => {
    disclaimerTrigger.current = disclaimerTriggerRef;
  };

  return (
    <React.Fragment>
      {strikeoutDisclaimer ? (
        <React.Fragment>
          <UitkMoreInfoTrigger>
            <LinkTracked linkName="Price Disclaimer Dialog" rfrr=".Price.DisclaimerDialog" to={query} role="button" innerRef={triggerRef}>
              <UitkIcon name="info_outline" className="pwa-theme--grey-700" />
              <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
            </LinkTracked>
          </UitkMoreInfoTrigger>
          <DisclaimerDialog
            dialogType={dialogType}
            disclaimerText={strikeoutDisclaimer}
            innerHTML={true}
            layerId={`price-disclaimer-dialog${layerId ? `-${layerId}` : ''}`}
            disclaimerTextId="price-disclaimer-text"
            handleClose={onDisclaimerDialogClose}
            {...{ dialogId }}
          />
        </React.Fragment>
      ) : (
        <StrikeoutPrice {...{ strikeOut, wrapPrice }} />
      )}
    </React.Fragment>
  );
};
